const now = new Date();
const jstOffset = 9 * 60 * 60 * 1000;
const jst = new Date(now.getTime() + jstOffset);

const month = jst.getUTCMonth() + 1;
const day = jst.getUTCDate();
const dayOfWeek = jst.getUTCDay();
const hour = jst.getUTCHours();
const isAfternoon = hour >= 12;

let text = '';

/* =========================
   ★ GW特別ルール
   5/1 12:00以降〜5/6 → 5/8-5/10
========================= */
const isGWRule =
  month === 5 &&
  (
    (day === 1 && isAfternoon) ||
    (day >= 2 && day <= 6)
  );

if (isGWRule) {
  text = '5月8日-10日';

} else {

  /* =========================
     ★ お盆特別ルール
     8/12 12:00以降〜8/16 → 8/18-8/20
  ========================= */
  const isObonRule =
    month === 8 &&
    (
      (day === 12 && isAfternoon) ||
      (day >= 13 && day <= 16)
    );

  if (isObonRule) {
    text = '8月18日-20日';

  } else {

    /* =========================
       ★ 年末年始 特別ルール
       12/31〜1/4 → 1/9-1/10
    ========================= */
    const isYearEndHoliday =
      (month === 12 && day === 31) ||
      (month === 1 && day >= 1 && day <= 4);

    if (isYearEndHoliday) {
      text = '1月9日-10日';

    } else {

      /* =========================
         ★ 通常ルール
      ========================= */
      let addStart = 1;
      let addEnd = 3;

      // 金曜12時以降は翌週火曜〜木曜想定
      if (dayOfWeek === 5 && isAfternoon) {
        addStart = 4;
        addEnd = 6;
      }

      const getFormattedDate = (baseDate, offset) => {
        const d = new Date(baseDate);
        d.setUTCDate(d.getUTCDate() + offset);

        return {
          month: d.getUTCMonth() + 1,
          day: d.getUTCDate()
        };
      };

      const start = getFormattedDate(jst, addStart);
      const end = getFormattedDate(jst, addEnd);

      if (start.month === end.month) {
        text = `${start.month}月${start.day}日-${end.day}日`;
      } else {
        text = `${start.month}月${start.day}日-${end.month}月${end.day}日`;
      }
    }
  }
}

const el = document.getElementById('delivery-date-range');
if (el) el.textContent = text;